/* eslint-disable no-param-reassign */
import { updateIntl } from 'react-intl-redux'

import { store } from '../store'
import { getLocaleMessages } from './index'
import { getStoredLanguage, normalizeLanguage } from '../utilities/lang'
import * as ACTIONS from './actions'

export default function fetchTranslation (locale) {
  // Honor the documented precedence chain (cookie → navigator → 'en')
  // instead of the legacy localStorage['locale'] read that ignored both
  // the dresez_lang cookie and the LanguageMenu's preference.
  if (!locale) {
    locale = getStoredLanguage()
  } else {
    locale = normalizeLanguage(locale) || 'en'
  }

  store.dispatch({ type: ACTIONS.TRANSLATION_FETCH })

  try {
    store.dispatch(
      updateIntl({
        locale,
        messages: getLocaleMessages(locale)
      })
    )

    store.dispatch({ type: ACTIONS.TRANSLATION_FETCH_SUCCESS, locale })
  } catch (err) {
    store.dispatch({
      type: ACTIONS.TRANSLATION_FETCH_FAIL,
      error: err.message
    })
  }
}
